import { getTeamPhotos } from "@/grid/lib/profile-photos";
import type { DepartmentId } from "@/grid/core/types";
import { cn } from "@/lib/cn";

interface TeamPhotoStackProps {
  teamName: string;
  department: DepartmentId;
  tvMode?: boolean;
  className?: string;
}

export function TeamPhotoStack({
  teamName,
  department,
  tvMode: _tvMode = false,
  className,
}: TeamPhotoStackProps) {
  const photos = getTeamPhotos(teamName, department);
  if (photos.length === 0) return null;

  return (
    <div className={cn("flex gap-1", className)}>
      {photos.map((photo) => (
        <img
          key={photo}
          src={photo}
          alt=""
          loading="eager"
          decoding="async"
          className="h-8 w-8 shrink-0 rounded-sm border border-[var(--color-border)] bg-white object-contain"
        />
      ))}
    </div>
  );
}
